import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useQuery } from "@tanstack/react-query";
import { LevelBParticipantCompetencyPointsResponse, LevelBReportFilter } from "../../types/levelb-reports";

interface UseGetLevelBParticipantCompetencyPointsParams {
  filter: LevelBReportFilter;
  enabled?: boolean;
}

export const useGetLevelBParticipantCompetencyPoints = ({
  filter,
  enabled = true,
}: UseGetLevelBParticipantCompetencyPointsParams) => {
  const axios = useAxios();
  const { t } = useTranslation();

  const fetchParticipantCompetencyPoints = async (): Promise<LevelBParticipantCompetencyPointsResponse> => {
    try {
      const params = new URLSearchParams({
        startDate: filter.startDate,
        endDate: filter.endDate,
      });

      if (filter.examTermId) {
        params.append('examTermId', filter.examTermId);
      }

      const { data } = await axios.get(`/api/levelbreports/participant-competency-points?${params.toString()}`);
      return data;
    } catch (error) {
      throw new Error(t("levelBReports.errors.getParticipantCompetencyPoints"));
    }
  };

  return useQuery({
    queryKey: ["levelBParticipantCompetencyPoints", filter],
    queryFn: fetchParticipantCompetencyPoints,
    enabled: enabled && Boolean(filter.startDate) && Boolean(filter.endDate) && Boolean(filter.examTermId),
  });
};

